import { render, staticRenderFns } from "./foodList.vue?vue&type=template&id=4f1f4dba&scoped=true"
import script from "./foodList.vue?vue&type=script&lang=js"
export * from "./foodList.vue?vue&type=script&lang=js"
import style0 from "./foodList.vue?vue&type=style&index=0&id=4f1f4dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f4dba",
  null
  
)

export default component.exports